import { Modal, baseVariables } from '@marriott/mi-ui-library';
import styled from 'styled-components';

const { mediaQuery } = baseVariables;

export const StyledModifyDatesOccupancyModal = styled(Modal)`
  .modal-body {
    .minihotel-info {
      text-decoration: underline;
    }

    .m-dropdown-container,
    .mobile-container {
      z-index: 4;
    }
    .dropdown {
      z-index: 3;
    }

    @media ${mediaQuery.md} {
      overflow: visible;
    }
  }
`;
